import workspace from "./workspace";
import { getFilteredWorkspaceData } from "@/utils/workspaceOrgFilter";
import { useStore } from "@/store";

export const getAgentGroups = async () => {
  const userOrg = useStore.userOrg();
  const  params =  { org_name: userOrg }
  try {
    return getFilteredWorkspaceData('/agent-groups/', 'organization', { params });
  } catch (error) {
    console.error("Error fetching agent groups:", error);
    throw error;
  }
};

export const getAgentGroupById = async (id) => {
  try {
    const response = await workspace.get(`/agent-groups/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching agent group with ID ${id}:`, error);
    throw error;
  }
};

export const createAgentGroup = async (groupData) => {
  try {
    const response = await workspace.post(`/agent-groups/`, groupData);
    return response.data;
  } catch (error) {
    console.error("Error creating agent group:", error);
    throw error;
  }
};

export const updateAgentGroup = async (id, groupData) => {
  try {
    const response = await workspace.put(`/agent-groups/${id}/`, groupData);
    return response.data;
  } catch (error) {
    console.error(`Error updating agent group with ID ${id}:`, error);
    throw error;
  }
};

export const deleteAgentGroup = async (id) => {
  try {
    const response = await workspace.delete(`/agent-groups/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting agent group with ID ${id}:`, error);
    throw error;
  }
};
